import { render, staticRenderFns } from "./AgriculturalMaterialsRank.vue?vue&type=template&id=702fc230&scoped=true"
import script from "./AgriculturalMaterialsRank.vue?vue&type=script&lang=js"
export * from "./AgriculturalMaterialsRank.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalMaterialsRank.vue?vue&type=style&index=0&id=702fc230&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702fc230",
  null
  
)

export default component.exports